import React, { Component } from "react";
import styled from "styled-components";
import url from "./img/url.png";

import "./App.css";
import { AiFillHeart } from "react-icons/ai";
import { MdSkipNext, MdSkipPrevious, MdPlayCircleFilled } from "react-icons/md";
import tel from './img/tel.png';
import Carousel from "react-multi-carousel";
import 'react-multi-carousel/lib/styles.css';


const Main = styled.div`
  width: 450px;
  height: 80vh;
  border-radius: 15px;

  display: flex;
  flex-direction: column;
  background-color: #71888f5e;

  @media (max-width: 375px) {
    width: 100%;
    height: 80vh;

    img {
      width: 50%;
    }
  }


  img {
    max-width: 400px;
    min-width: 300px;

    height: auto;
    padding: 5%;
    margin: 0 auto;
  }

  h6 {
    font-weight: 500;
    font-size:15px;

  }
  p {
    font-weight: 300;
    font-size: 18px;
  }
  #play {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 50px;
  }
`;
const responsive = {
  superLargeDesktop: {
    // 8the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};
const Content=styled.div`
width: 450px;
@media (max-width:500px){
  width: 100%;
}
`
const Tel=styled.div`
margin: 0 auto;
img{

display: flex;
width: 200px;
justify-content: center;
border-radius: 10px;
}

#telplay{
  font-size: 50px;
}
@media (max-width:500px){

  img{

display: flex;
width: 170px;
justify-content: center;
border-radius: 10px;
}

#telplay{
  font-size: 30px;
}
h6{
  font-size:12px;
}
p{font-size:7px}
}
`


export class Spotify extends Component {

  
  render() {
    const {name,track,image,color}=this.props.state
    return (
      <Content >
        <Carousel
          responsive={responsive}
          additionalTransfrom={0}
          ssr
          partialVisbile
          arrows
          autoPlaySpeed={3000}
          centerMode={false}
          className=""
          containerClass="container-with-dots"
          dotListClass=""
          draggable
          focusOnSelect={false}
          infinite
          itemClass=""
          keyBoardControl
          minimumTouchDrag={80}
          renderButtonGroupOutside={true}
          renderDotsOutside={true}
          
        >

        <Main>
          <img src={image} alt="pp" className="img-spotify"/>
          <div 
            style={{
              display: "flex",
              justifyContent: "start",
              padding: "0 30px",
            }}
            >
            <div style={{ flex: "1", textAlign: "left",color:color}}>
              <h6>{track}</h6>
              <p>{name} </p>
            </div>
            <AiFillHeart size="30px" color={this.props.state.color}/>
          </div>
          {/*    <FaRandom/>*/}
          <div id="play">
            <MdSkipPrevious  color={this.props.state.color}/>
            <MdPlayCircleFilled color={this.props.state.color}/>
            <MdSkipNext color={this.props.state.color}/>
          </div>
          <img src={url} alt="pp" />
         
        </Main>
        <div style={{width:"100%",display:"flex",justifyContent:"center"}}>
          <img src={tel} alt="tel" style={{height:"80vh",position:"relative"}}
          />

          <div style={{position:"absolute",top:"32%"}}>
            <Tel >
            <img src={image} alt="pp" />
            <div style={{ flex: "1", textAlign: "left",color:color}}>
              <h6 style={{marginTop:"5px"}}>{track}</h6>
              <p >{name} </p>
            </div>
            <div id="telplay">
            <MdSkipPrevious  color={this.props.state.color}/>
            <MdPlayCircleFilled color={this.props.state.color}/>
            <MdSkipNext color={this.props.state.color}/>
{/*             <img src={url} alt="pp"style={{width:"150px"}} />
 */}
          </div>

            </Tel>
          </div>
        </div>
            </Carousel>
      </Content>
    );
  }
}

export default Spotify;
